import type { TPAComponentProps } from '../../types';

export interface EventProps extends TPAComponentProps {
  time?: string;
  title: string;
  showTime?: boolean;
  fullday?: boolean;
  selected?: boolean;
  disabled?: boolean;
  onClick?(): void;
  'aria-has-popup'?: boolean;
  'aria-expanded'?: boolean;
}

export interface EventDefaultProps {
  showTime: boolean;
  fullday: boolean;
  selected: boolean;
  disabled: boolean;
  onClick(): void;
  'aria-has-popup'?: boolean;
  'aria-expanded': boolean;
}

export enum EventDataKeys {
  IsTimeShown = 'data-time-shown',
  IsFullDay = 'data-fullday',
  IsRightToLeft = 'data-right-to-left',
  IsSelected = 'data-selected',
  ARIA_Has_Popup = 'aria-haspopup',
  ARIA_Expanded = 'aria-expanded',
}
